import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { MarkerSetDialogComponent } from './marker-set-dialog.component';
import { AccessibleDropListDirective } from '@go-modules/directives/accessible-drop-list/accessible-drop-list.directive';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ColorMenuModule } from '@go-modules/components/color-menu/color-menu.module';
import { TwoLettersPipeModule } from '@go-modules/pipes/two-letters/two-letters.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		A11yModule,
		FocusOnFirstInvalidFieldModule,
		DragDropModule,
		AccessibleDropListDirective,
		ColorMenuModule,
		TwoLettersPipeModule
	],
	declarations: [
		MarkerSetDialogComponent
	],
	exports: [
		MarkerSetDialogComponent
	]
})
export class MarkerSetDialogModule {}
